export default "__VITE_ASSET__FI5kC7Mq__"